module.exports = __webpack_public_path__ + "img/e-mail@2x.dc99327.png";